<template>
<div id="chargesSummary">

  <div v-for="(s, idx) in sections" :key="'section-'+idx" class="chg-section">
    <div class="mb-8"><span class="fs-16">{{s.label}}</span>
      <span style="float: right" class="fs-16">
        <i v-if="chargesNA[s.chargesNAKey]" class="fas fa-check-square" style="color: #2d8cf0"></i>
        <i v-else class="far fa-square"></i> Charges Not Applicable
      </span>
    </div>
    <Table :columns="columns" :data="$data[s.chargesKey]" size="small" :no-data-text="'No '+s.label+' added'">
      <template slot-scope="{ row }" slot="chargeType"><span class="capitalize">{{row.label}}</span></template>
      <template slot-scope="{ row }" slot="amount">{{row.amount | currencyFilter}}</template>
      <template slot-scope="{ row }" slot="query">
        <i v-if="row.query" class="fas fa-check-square" style="color: #2d8cf0"></i>
        <i v-else class="far fa-square"></i>
      </template>
    </Table>
  </div>

  <div class="freight-section">
    <div class="mb-8"><span class="fs-16">Freight Charges</span></div>
    <Table :columns="columns.slice(0, 3)" :data="freightCharges" size="small">
      <template slot-scope="{ row }" slot="chargeType"><span class="capitalize">{{row.label}}</span></template>
      <template slot-scope="{ row }" slot="amount">{{row.amount | currencyFilter}}</template>
    </Table>
  </div>
  <div class="total-amt-section">
    <h2><span>Total Amount</span><span style="margin-left: 200px">{{totalAmount | currencyFilter}}</span></h2>
  </div>

</div>
</template>

<script>
import {GET_ALL_CHARGES} from "../../graphql/queries/clientInvoices";
import {Constants} from "../../Constants/Constant";
import moment from 'moment';
import {sortVectorArray} from "../../util/helpers";
let chargesNA = {orderCity:false, pickupCity:false, dropCity:false};
export default {
  name: "ChargesSummary",
  props: ['clientInvoiceId'],
  apollo: {
    charges: {
      query: GET_ALL_CHARGES,
      fetchPolicy: 'network-only',
      skip() { return !this.clientInvoiceId },
      variables() {return { clientInvoiceId: this.clientInvoiceId }},
      result({data}) { this.setCharges(data) }
    },
  },
  data(){
    return{
      Constants: Constants,
      moment: moment,
      orderCityCharges: [],
      pickupCityCharges: [],           /* If empty then no pickupCityCharges added */
      dropCityCharges: [],
      chargesNA: {...chargesNA},
      clientInvoice: {},
      columns: [
        {title: 'Type of Charge', slot: 'chargeType', width:300},
        {title: 'Amount', slot: 'amount'},
        {title: 'Note', key: 'note'},
        {title: 'Query', slot: 'query'},
      ],
      sections: [
        {label:'Order City Charges', chargesKey:'orderCityCharges', chargesNAKey: 'orderCity'},
        {label:'Pickup City Charges', chargesKey:'pickupCityCharges', chargesNAKey: 'pickupCity'},
        {label:'Drop City Charges', chargesKey:'dropCityCharges', chargesNAKey: 'dropCity'},
      ],
      freightCharges: [{label:'Special Offered Freight', amount:'', note:''}, {label:'Billing Freight', amount:'', note:'-'}],
      totalAmount: 0
    }
  },
  methods:{
    setCharges(data){                                /* Extract charges by pointType & sort */
      this.resetCharges();
      let orderChargeTypes = [], pickupChargeTypes = [], dropChargeTypes = [], orderCharges = [], pickupCharges = [], dropCharges = [];
      data.charges.forEach(c => { c.label = c.ChargeType.type.toLowerCase();
        if(c.pointType === Constants.PointTypes.OrderCity) orderCharges.push(c);
        else if(c.pointType === Constants.PointTypes.PickupCity) pickupCharges.push(c);
        else if(c.pointType === Constants.PointTypes.DropCity) dropCharges.push(c);
        this.totalAmount = this.totalAmount + c.amount;
      });
      data.chargeTypes.forEach(t => {           /* It preserve sequence of charges */
        if(t.pointType === Constants.PointTypes.OrderCity) orderChargeTypes.push(t.chargeType);
        else if(t.pointType === Constants.PointTypes.PickupCity) pickupChargeTypes.push(t.chargeType);
        else if(t.pointType === Constants.PointTypes.DropCity) dropChargeTypes.push(t.chargeType);
      });
      this.orderCityCharges = sortVectorArray(orderChargeTypes, orderCharges, 'chargeType');
      this.pickupCityCharges = sortVectorArray(pickupChargeTypes, pickupCharges, 'chargeType');
      this.dropCityCharges = sortVectorArray(dropChargeTypes, dropCharges, 'chargeType');

      data.chargesNA.forEach(c => {
        if(c.pointType === Constants.PointTypes.OrderCity) this.chargesNA.orderCity = c.chargesNotApplicable;
        else if(c.pointType === Constants.PointTypes.PickupCity) this.chargesNA.pickupCity = c.chargesNotApplicable;
        else if(c.pointType === Constants.PointTypes.DropCity) this.chargesNA.dropCity = c.chargesNotApplicable;
      });

      this.clientInvoice = data.clientInvoices[0];
      this.freightCharges[0].amount = this.clientInvoice.Order.orderDetails.splOfferedFreight;
      this.freightCharges[0].note = this.clientInvoice.Order.orderDetails.splOfferedFreightNote;
      this.freightCharges[1].amount = this.clientInvoice.billingFreight;
      this.totalAmount = this.totalAmount + this.clientInvoice.billingFreight;
    },
    validateCharges(){
      let errors = [];

      if(!this.orderCityCharges.length) errors.push('No Order City Charges Added');
      else if(!this.chargesNA.orderCity && this.orderCityCharges.find(c => c.query)) errors.push('Order City Charges include query');

      if(!this.pickupCityCharges.length) errors.push('No Pickup City Charges Added');
      else if(!this.chargesNA.pickupCity && this.pickupCityCharges.find(c => c.query)) errors.push('Pickup City Charges include query');

      if(!this.dropCityCharges.length) errors.push('No Drop City Charges Added');
      else if(!this.chargesNA.dropCity && this.dropCityCharges.find(c => c.query)) errors.push('Drop City Charges include query');

      if(this.clientInvoice.billingFreight === null) errors.push('No Billing Freight Added');

      return errors;
    },
    resetCharges(){
      this.orderCityCharges = [];
      this.pickupCityCharges = [];
      this.dropCityCharges = [];
      this.chargesNA = {...chargesNA};
      this.clientInvoice = {};
      this.totalAmount = 0;
    }
  }
}
</script>

<style scoped>
#chargesSummary{
  padding: 4px;
}
.capitalize{
  text-transform: capitalize;
}
.fs-16{
  font-size: 16px;
}
.fs-18{
  font-size: 18px;
}
.fw-600{
  font-weight: 600;
}
.mb-8{
  margin-bottom: 8px;
}
.chg-section{
  margin-bottom: 20px;
  /*border: 1px solid #eee;*/
  /*border-radius: 5px;*/
  padding: 10px 14px;
}
.chg-section:hover{
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
}
.freight-section{
  margin-bottom: 10px;
  padding: 10px 14px;
}
.freight-section:hover{
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
}
.total-amt-section{
  margin-bottom: 60px;
  padding: 0 0 0 30px;
}
</style>
